import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";
import { Button, IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import Box from "@mui/material/Box";

export const StyledChannelPerformanceCard = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: "4px",
  padding: "12px",
  boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.05)",
}));

export const StyledInfoBox = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  borderLeft: `1px solid #DBDBDB`,
  padding: "8px",
  "&:last-child": {
    borderRight: `1px solid #DBDBDB`,
  },
  position: "relative",
}));

export const StyledInfoBoxTitle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 500,
  color: "#212121",
  marginBottom: "4px",
  lineHeight: "normal",
  height: "30px",
}));

export const StyledInfoBoxNumber = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  fontSize: "18px",
  fontWeight: 700,
  lineHeight: "normal",
  marginBottom: "12px",
}));

export const StyledCVRText = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  fontSize: "12px",
  color: theme.customColors.grey[600],
  lineHeight: "normal",
  marginBottom: "8px",
  display: "flex",
  alignItems: "center",
}));

export const StyledCVRValue = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  fontSize: "12px",
  color: theme.customColors.grey[900],
  lineHeight: "normal",
  marginBottom: "8px",
  height: "16px",
  display: "flex",
  alignItems: "center",
}));

export const StyledBlurBox = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, isLocked }) => ({
  ...(isLocked && {
    filter: "blur(5px)",
  }),
}));

export const StyledLockedText = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => ({
  color: theme.customColors.purple[500],
  position: "absolute",
  fontWeight: 700,
  fontSize: "10px",
  top: "53%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  whiteSpace: "nowrap",
}));
